import { Transaction } from "appworks/services/transaction/transaction";
import { Contract } from "appworks/utils/contracts/contract";
import { Parallel } from "appworks/utils/contracts/parallel";
import { logger } from "appworks/utils/logger";
import { gamevy } from "gamevy/gamevy";

export class GamevyTransaction extends Transaction {
    protected previousWinAmount: number = 0;

    public setBalance(value: number) {
        if (value !== null) {
            if (this.previousBalance !== value) {
                logger.log("GCUI", "UpdateBalance", value);
                gamevy.commonUI.updateBalance({ amount: value }, {
                    promoInfo: gamevy.balancePromoInfo,
                    realAmount: gamevy.balanceData?.REAL,
                    bonusAmount: gamevy.balanceData?.BONUS
                });
            }
        }

        super.setBalance(value);
    }

    public setWinnings(currentWin: number, totalWin?: number, tickTime: number = 0): Contract<void> {
        return new Parallel([
            () => super.setWinnings(currentWin, totalWin, tickTime),
            () => Contract.wrap(() => {
                const winAmount: number = totalWin || currentWin;
                if (winAmount > 0 && winAmount !== this.previousWinAmount) {
                    logger.log("GCUI", "UpdateWin", winAmount);
                    gamevy.commonUI.updateWin({ amount: winAmount });
                    this.previousWinAmount = winAmount;
                }
            })
       ]);
    }
}
